import { render } from "./VariantsList.vue?vue&type=template&id=f3f5d24c&scoped=true"
import script from "./VariantsList.vue?vue&type=script&lang=js"
export * from "./VariantsList.vue?vue&type=script&lang=js"

import "./VariantsList.vue?vue&type=style&index=0&id=f3f5d24c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f5d24c"]])

export default __exports__